import React from 'react';
import { Header } from '@/job-portal/components/Header';
import LoginModal from './LoginModal';

interface ContextualLoginPageProps {
  title?: string;
  description?: string;
  contextDescription?: string;
  jobTitle?: string;
  companyName?: string;
  isDashboardLogin?: boolean;
  isAssessment?: boolean;
}

const ContextualLoginPage: React.FC<ContextualLoginPageProps> = ({
  title,
  description,
  contextDescription,
  jobTitle,
  companyName,
  isDashboardLogin,
  isAssessment,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-background">
      <Header hideSignIn />
      <main className="flex items-center justify-center min-h-[calc(100vh-80px)] px-4 py-8">
        <div className="w-full max-w-md">
          {(title || description) && (
            <div className="text-center mb-8">
              {title && (
                <h1 className="text-3xl font-bold text-text-primary mb-3">
                  {title}
                </h1>
              )}
              {description && (
                <p className="text-text-secondary text-lg">
                  {description}
                </p>
              )}
            </div>
          )}

          {/* Single unified card */}
          <div className="bg-white p-8 rounded-2xl shadow-2xl w-full">
            <LoginModal
              contextDescription={contextDescription}
              jobTitle={jobTitle}
              companyName={companyName}
              hideCloseButton={true}
              isInline={true}
              isDashboardLogin={isDashboardLogin}
              isAssessment={isAssessment}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContextualLoginPage;
